import { HTTP } from '../../../http-common';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';

const state = {
  rows: [],
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setProgress(state, message) {
    state.message = message;
  },
  updateField,
};

//ACTIONS
const actions = {
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  filterCommissionTarget({ commit, dispatch }, payload) { 
    return new Promise((resolve, reject) => {
      var response = HTTP.post('oms/FilterCommissionTargets', payload);
      response
        .then(data => {
          var resultData = data.data;
          commit(
            'setProgress',
            new httpError({
              message: 'Commission Targets Retrieved',
              httpStatus: 200,
            })
          );
          resolve(resultData);
          return;
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },
  getCommissionTargets({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('oms/GetCommissionTargets');
      response
        .then(data => {
          var resultData = data.data;
          commit(
            'setProgress',
            new httpError({
              message: 'Commission Targets Retrieved',
              httpStatus: 200,
            })
          );
          resolve(resultData);
          return;
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },
  upsertCommissionTargets({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('oms/UpsertCommissionTargets', payload);
      response
        .then(data => {
          var resultData = data.data;
          commit(
            'setProgress',
            new httpError({
              message: 'Commission Targets Updated',
              httpStatus: 200,
            })
          );
          resolve(resultData);
          return;
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },
  deleteCommissionTargets({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('oms/DeleteCommissionTargets', payload);
      response
        .then(data => {
          var resultData = data.data;
          commit(
            'setProgress',
            new httpError({
              message: 'Commission Targets Deleted',
              httpStatus: 200,
            })
          );
          resolve(resultData);
          return;
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
